import { tokens, Typography, View, Flex, Button } from "@sapphire-react/core";
import styled from "styled-components";
import type { LoanInsuranceForm } from "../types";
import { track, trackCalculatorSubmit } from "../utils/sitecoreTrack";
import { DonutAndNumbers } from "./DonutAndNumbers";

type FormProps = {
  data?: LoanInsuranceForm;
  isValid: boolean;
};

export const Results = ({ data, isValid }: FormProps) => (
    <StyledView aria-disabled={!isValid} isDisabled={!isValid}>
      <View
        alignItems={"center"}
        backgroundColor={tokens.color.backgroundSurface.value}
        paddingBottom={tokens.size.spacingXl}
        paddingTop={tokens.size.spacingXl}
        borderRadius={tokens.size.borderSm}
      >
        <Typography.Heading level={5} textAlign={"center"} elementType={"h4"}>
          Total månadspremie
        </Typography.Heading>

        <DonutAndNumbers data={data} isValid={isValid} />
        <Flex flexFlow={"row wrap"} justifyContent={"center"}>
          <Button
            elementType={"button"}
            variant={"primary"}
            name={"book-meeting-button"}
            marginTop={tokens.size.spacingLg}
            data-test-id={"book-meeting-button"}
            arialabel-={"Boka onlinemöte"}
            isDisabled={!isValid}
            onPress={() => {
              trackCalculatorSubmit(
                "0",
                `Age: ${data?.age}, Betalskydd: ${data?.paymentProtection}, Livskydd: ${data?.lifeProtection}`,
              );
              track("click:book meeting:boka emote");
              window.open("https://danskebank.se/boka-mote", "_blank");
            }}
          >
            Boka onlinemöte
          </Button>
        </Flex>
      </View>
    </StyledView>
  );

interface StyledViewProps {
  isDisabled?: boolean;
}
const StyledView = styled.div<StyledViewProps>`
  pointer-events: ${({ isDisabled }) => (isDisabled ? "none" : "auto")};
  opacity: ${({ isDisabled }) =>
    isDisabled ? tokens.opacity.disabled.value : 1};
  & * {
    ${({ isDisabled }) => isDisabled && "tab-index: -1;"}
  }
`;
